import Format from "../components/format/Format";
import { ButtonValues } from "../types/button.type";

export default function Url() {
    const buttons: ButtonValues[] = [
        {
            api: '/api/url/encode',
            buttonLabel: 'Encode',
            outputLabel: 'Encoded',
        },
        {
            api: '/api/url/decode',
            buttonLabel: 'Decode',
            outputLabel: 'Decoded',
        },
    ];

    return (
        <Format inputLabel='URL' buttons={buttons} />
    );
}